import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';

const devUrl = environment.backendurl

@Injectable({
  providedIn: 'root'
})
export class IframeSearchtoolboxserviceService {

  constructor(private http: HttpClient) { 
  }

  getAutoCompleteDataList(data){
    var url = devUrl + "/searchtoolbox/iframeautocomplete_dropdown_data"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Related Data ', url)));
  }


  recommendedData(data){
    var url = devUrl + "/searchtoolbox/iframerelated_data"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Related Data ', url)));
  }


  linkedInSearch(data){
    var url = devUrl + "/searchtoolbox/iframelinkedinsearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('LinkedIn Search: ', url)));
  }

  xingSearch(data){
    var url = devUrl + "/searchtoolbox/iframexingsearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Xing Search: ', url)));
  }

  quoraSearch(data){
    var url = devUrl + "/searchtoolbox/iframequorasearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Quora Search: ', url)));
  }


  githubSearch(data){
    var url = devUrl + "/searchtoolbox/iframegithubsearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('GitHub Search: ', url)));
  }

  stackOverflowSearch(data){
    var url = devUrl + "/searchtoolbox/iframestackoverflowsearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Stack Overflow Search: ', url)));
  }

  behanceSearch(data){
    var url = devUrl + "/searchtoolbox/iframebehancesearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Behance Search: ', url)));
  }


  twitterSearch(data){
    var url = devUrl + "/searchtoolbox/iframetwittersearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Twitter Search: ', url)));
  }

} 
